export default __webpack_public_path__ + "images/referenzen/socialmedia/edeka_rezeptvideo_mit_kev_poutine.mp4";